import Service from "../../Service";
import Axios from "../../Config/API";
import { ICasoCobrancaFato } from "../../../Interfaces/Cobranca/CasoCobancaFato/CasoCobrancaFatoInterfaces";

export async function GetCasoCobrancaFatoService(idChaveErp: string) {
    return Service(
        Axios.post<ICasoCobrancaFato>(
            `/cobranca/casocobrancafato/getcasocobrancafatoporchave?idChaveErp=${idChaveErp}`
        )
    );
}
